export default {
  name: 'quantity',
  type: 'action',
  isRequired: false,
  essential: true
}
